export const FullDealMobileAppActionsTexts = {
  getInApp: 'Получить займ в приложении',
  continueWebsite: 'Продолжить на сайте',
};
